import React from 'react'
import '../App.css';
import { useEffect, useState } from "react";


function TableCheckout({Entrega}){

    const [carrito, setCarrito] = useState([]);

    useEffect(()=>{
        const storeProductos = JSON.parse(localStorage.getItem('Registrados'));
        if(storeProductos){
          setCarrito(storeProductos);
        }
      }
    ,[])

    let total=0;

    const sumall = carrito.map(item => item.Price);
    sumall.forEach(function(a){total+=a;});

    let sumatotal = total+Entrega;

    return (
        <div className='table-form-direction'>
            <table>
                <thead>
                    <tr>
                        <th>Producto</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                    </tr>
                </thead>
                <tbody>
                    {carrito.map((c)=>{
                        return(
                            <tr>
                                <td>
                                    <img src={c.Image} alt="" /><br />
                                    {c.Title}
                                </td>
                                <td>1</td>
                                <td>RD$ {c.Price}.00</td>
                            </tr>
                        )
                    })}
                    <tr className='agregado-entrega'>
                        <td>Entrega:</td>
                        <td></td>                    
                        <td>RD$ {Entrega}.00</td>
                    </tr>
                    <tr className='agregado-entrega'>
                        <td>Subtotal:</td>
                        <td></td>                    
                        <td>RD$ {sumatotal}.00</td>
                    </tr>
                    <tr className='agregado-entrega'>
                        <td>Impuestos:</td>
                        <td></td>                    
                        <td>RD$ 0.00</td>
                    </tr>
                </tbody>
                <thead>
                    <tr>
                        <th>Total</th>
                        <th>{sumall.length}</th>
                        <th>RD$ {sumatotal}.00</th>
                    </tr>
                </thead>
            </table>
        </div>
    )
}

export default TableCheckout
